import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/future/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { useLocalStorage } from '@platzi/commons';
import { imageLoader } from 'src/utils/imageOptimizer';
import styles from './WhatIsSchool.module.sass';

export const WhatIsSchool = () => {
  const { t } = useTranslation();
  const [showContent, setShowContent] = useLocalStorage('WhatIs', 'true');

  const handleContent = () => setShowContent(showContent === 'true' ? 'false' : 'true');

  if (showContent === 'false') return null;

  return (
    <div className={styles.WhatIsSchool}>
      <div className="u-wrapper">
        <div
          className={styles.Card}
          style={{
            backgroundImage:
              'url(https://static.platzi.com/media/uploads/thumbnail_school_bg_marketing_2x_a501fe11b8.png)',
          }}
        >
          <Image
            loader={imageLoader}
            src="https://static.platzi.com/media/uploads/whatis2x_05b814b167.png"
            alt={t('escuela.whatIs.title')}
            width={161}
            height={192}
          />
          <div>
            <h6>{t('escuela.whatIs.title')}</h6>
            <p>{t('escuela.whatIs.copy')}</p>
          </div>
          <button type="button" onClick={handleContent}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>
    </div>
  );
};
